import { render, staticRenderFns } from "./PreQuestion1.vue?vue&type=template&id=a69cd00a&scoped=true&"
import script from "./PreQuestion1.vue?vue&type=script&lang=js&"
export * from "./PreQuestion1.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion1.vue?vue&type=style&index=0&id=a69cd00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69cd00a",
  null
  
)

export default component.exports